// import {Masks} from 'react-native-mask-input';

/* eslint-disable no-useless-escape */
export type MaskInputProps =
  | 'date'
  | 'datetime'
  | 'phone'
  | 'mobilePhone'
  | 'cep'
  | 'cpf'
  | 'cnpj'
  | 'cpfOrCnpj'
  | 'hours'
  | 'rg'
  | 'number'
  | 'percentage'
  | 'money'
  | 'card'
  | 'dateForCard'
  | 'text'
  | 'datePicker'
  | 'float'
  | 'prefix'
  | 'coordinates'
  | 'floatAndComma';

export const maskInput = (text: string, type?: MaskInputProps) => {
  if (type === 'number') {
    const mask = [];
    const regex = /^\d+$/;
    for (let i = 0; i < text.length; i++) {
      mask.push(regex);
    }
    return mask;
  }

  if (type === 'text') {
    const mask = [];
    const regex = /^[A-Za-zÀ-ÿ\s]*$/;
    for (let i = 0; i < text.length; i++) {
      mask.push(regex);
    }
    return mask;
  }

  if (type === 'floatAndComma') {
    const regex = /^[\d|\.|\,]+/;
    const mask = [];

    for (let i = 0; i < text.length; i++) {
      mask.push(regex);
    }
    return mask;
  }

  if (type === 'prefix') {
    return [
      /^[A-Za-zÀ-ÿ\s]*$/,
      /^[A-Za-zÀ-ÿ\s]*$/,
      '-',
      /^[A-Za-zÀ-ÿ\s]*$/,
      /^[A-Za-zÀ-ÿ\s]*$/,
      /^[A-Za-zÀ-ÿ\s]*$/,
    ];
  }

  if (type === 'coordinates') {
    return [
      /\d/,
      /\d/,
      '°',
      /\d/,
      /\d/,
      '’',
      /\d/,
      /\d/,
      ' ',
      /^[A-Za-zÀ-ÿ\s]*$/,
      ' ',
      /\d/,
      /\d/,
      /\d/,
      '°',
      /\d/,
      /\d/,
      '’',
      /\d/,
      /\d/,
      ' ',
      /^[A-Za-zÀ-ÿ\s]*$/,
    ];
  }

  if (type === 'percentage') {
    const cleanText = text.replace(/\D+/g, '');
    if (!cleanText.charAt(2)) {
      return [/\d/, /\d/];
    }

    if (!cleanText.charAt(4)) {
      return [/\d/, /\d/, '.', /\d/, /\d/];
    }

    return [/\d/, /\d/, /\d/, '.', /\d/, /\d/];
  }

  if (type === 'phone') {
    return [
      '(',
      /\d/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  }

  if (type === 'cep') {
    return [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  }

  if (type === 'float') {
    const regex = /^\d*\.?\d*$/;
    const mask = [];

    for (let i = 0; i < text.length; i++) {
      mask.push(regex);
    }
    return mask;
  }

  if (type === 'card') {
    return [
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  }

  if (type === 'mobilePhone') {
    return [
      '(',
      /\d/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  }

  if (type === 'date') {
    const cleanText = text.replace(/\D+/g, '');

    let secondDigitDayMask = /\d/;

    if (cleanText.charAt(0) === '0') {
      secondDigitDayMask = /[1-9]/;
    }
    if (cleanText.charAt(0) === '3') {
      secondDigitDayMask = /[01]/;
    }

    let secondDigitMonthMask = /\d/;

    if (cleanText.charAt(2) === '0') {
      secondDigitMonthMask = /[1-9]/;
    }
    if (cleanText.charAt(2) === '1') {
      secondDigitMonthMask = /[012]/;
    }

    return [
      /[0-3]/,
      secondDigitDayMask,
      '/',
      /[0-1]/,
      secondDigitMonthMask,
      '/',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  }

  if (type === 'datetime') {
    const cleanText = text.replace(/\D+/g, '');

    let secondDigitDayMask = /\d/;
    if (cleanText.charAt(0) === '0') {
      secondDigitDayMask = /[1-9]/;
    }
    if (cleanText.charAt(0) === '3') {
      secondDigitDayMask = /[01]/;
    }

    let secondDigitMonthMask = /\d/;
    if (cleanText.charAt(2) === '0') {
      secondDigitMonthMask = /[1-9]/;
    }
    if (cleanText.charAt(2) === '1') {
      secondDigitMonthMask = /[012]/;
    }

    let secondDigitHourMask = /\d/;
    if (cleanText.charAt(11) === '2') {
      secondDigitHourMask = /[0-3]/;
    }

    let secondDigitMinuteMask = /\d/;

    return [
      /[0-3]/, // Dia: Primeiro dígito
      secondDigitDayMask, // Dia: Segundo dígito
      '/',
      /[0-1]/, // Mês: Primeiro dígito
      secondDigitMonthMask, // Mês: Segundo dígito
      '/',
      /\d/, // Ano: Primeiro dígito
      /\d/, // Ano: Segundo dígito
      /\d/, // Ano: Terceiro dígito
      /\d/, // Ano: Quarto dígito
      ' ', // Espaço entre data e hora
      /[0-2]/, // Hora: Primeiro dígito
      secondDigitHourMask, // Hora: Segundo dígito
      ':', // Separador de horas e minutos
      /[0-5]/, // Minuto: Primeiro dígito
      secondDigitMinuteMask, // Minuto: Segundo dígito
    ];
  }

  if (type === 'dateForCard') {
    const cleanText = text.replace(/\D+/g, '');

    let secondDigitMonthMask = /\d/;

    if (cleanText.charAt(0) === '0') {
      secondDigitMonthMask = /[1-9]/;
    }
    if (cleanText.charAt(0) === '1') {
      secondDigitMonthMask = /[012]/;
    }

    return [/[0-1]/, secondDigitMonthMask, '/', /\d/, /\d/];
  }

  if (type === 'hours') {
    const cleanText = text.replace(/\D+/g, '');

    let secondDigitMonthMask = /\d/;

    if (cleanText.charAt(0) === '0') {
      secondDigitMonthMask = /[0-9]/;
    }
    if (cleanText.charAt(0) === '1') {
      secondDigitMonthMask = /[0-9]/;
    }
    if (cleanText.charAt(0) === '2') {
      secondDigitMonthMask = /[0-3]/;
    }

    return [/[0-2]/, secondDigitMonthMask, ':', /[0-5]/, /[0-9]/];
  }

  if (type === 'cpf') {
    return [
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
    ];
  }

  if (type === 'cpfOrCnpj') {
    if (text.length > 14) {
      return [
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '/',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
      ];
    }
    return [
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
    ];
  }

  if (type === 'cnpj') {
    return [
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '/',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
    ];
  }

  if (type === 'rg') {
    return [
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
    ];
  }

  // if (type === 'money') {
  //   return Masks.BRL_CURRENCY;
  // }

  return '';
};
